import { useEffect } from "react";

import AgreementConfigAndSend from "features/agreements2/components/Agreement/AgreementConfigAndSend";
import AgreementFields from "features/agreements2/components/Agreement/AgreementFields";
import AgreementSign from "features/agreements2/components/Agreement/AgreementSign";
import CreateAgreementForm from "features/agreements2/components/Agreement/CreateAgreementForm";
import EditAgreementForm from "features/agreements2/components/Agreement/EditAgreementForm";
import { useAgreementContext } from "features/agreements2/components/Agreement/context/AgreementContext";
import useAgreementData from "features/agreements2/components/Agreement/hooks/useAgreementData";

const AgreementByUIState = () => {
  const { agreementUIStatus, setAgreementUIStatus } = useAgreementContext();
  const { agreement } = useAgreementData();

  useEffect(() => {
    if (!agreement?._id) {
      setAgreementUIStatus("create");
    } else if (!agreement.adminHasSent && !agreement.signedOffPlatform) {
      // Only go to config for regular agreements that need BoldSign setup
      setAgreementUIStatus("config");
    } else {
      // Off-platform agreements or already sent agreements go straight to edit
      setAgreementUIStatus("edit");
    }
  }, [agreement, setAgreementUIStatus]);

  if (agreementUIStatus === "config") {
    return <AgreementConfigAndSend />;
  }
  if (agreementUIStatus === "sign") {
    return <AgreementSign />;
  }
  if (agreementUIStatus === "create") {
    return (
      <CreateAgreementForm>
        <AgreementFields />
      </CreateAgreementForm>
    );
  }
  if (agreementUIStatus === "edit") {
    return (
      <EditAgreementForm>
        <AgreementFields />
      </EditAgreementForm>
    );
  }
  return null;
};

export default AgreementByUIState;
